import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsVideoElementInputPipe } from "./pipes/as-video-element-input.pipe";
import { IsVideoSlidePipe } from "./pipes/is-video-slide.pipe";

@NgModule({
    imports: [
        CommonModule,
        AsVideoElementInputPipe,
        IsVideoSlidePipe,
    ],
    exports: [
        AsVideoElementInputPipe,
        IsVideoSlidePipe,
    ],
})
export class SharedClassroomPreviewScreenUiInputPipesModule {}
